export function authHeader() {
  let user = JSON.parse(localStorage.getItem("user"));

  if (user && user.refreshedTokens.accessToken) {
    return { Authorization: "Bearer " + user.refreshedTokens.accessToken };
  } else {
    return {};
  }
}
